import { getRestaurantInfo, getWaitingCount, getMenuList } from '@/api/waiting'
import store from '@/store/index'

export default {
  async setRestaurantMenuList ({ state, commit }) {
    const idx = store.getters.getStoreIdx
    const params = {
      restaurantIdx: idx,
      numOfPeople: store.getters.getWaitingParams.numOfPeople || 1,
      childCount: store.getters.getWaitingParams.childCount
    }
    try {
      const { data } = await getMenuList(params)
      const menuInfo = data
      menuInfo.list = data.list.filter((cate) => {
        if (cate.menus.length > 0) { return cate }
      })
      commit('restaurantMenuInfo', menuInfo)
    } catch (error) {
      console.error('getMenuList error---', error)
    }
  },
  async setWaitingCount ({ commit }, restaurantIdx) {
    const idx = store.getters.getStoreIdx
    try {
      const { data } = await getWaitingCount(idx)
      commit('waitingCount', data.count)
      commit('queueList', data.waitingQueue)
    } catch (error) {
      console.error('getWaitingCount error---', error)
    }
  },
  async setRestaurant ({ commit }, restaurantIdx) {
    try {
      const { data } = await getRestaurantInfo(restaurantIdx)
      const restaurant = data.restaurantOption
      restaurant.name = data.name
      restaurant.status = data.waitingServiceScope
      restaurant.isCWType = data.isCWType
      restaurant.isRemoteWaitingOrderType = data.isRemoteWaitingOrderType
      restaurant.isWType = data.isWType
      restaurant.notice = { basic: '', confirm: '' }
      if (data.messages && data.messages.length) {
        restaurant.message = data.messages.find(massage => massage.lang === 'ko').message
      }
      if (data.restaurantNotice.length > 0) {
        const basic = data.restaurantNotice.find(arr => arr.type === 'ON_SITE_WAITING_BASIC')
        const confirm = data.restaurantNotice.find(arr => arr.type === 'ON_SITE_WAITING_CONFIRM')
        restaurant.notice = {
          basic: (basic === undefined) ? '' : basic.contents.replace(/(?:\r\n|\r|\n)/g, '<br>'),
          confirm: (confirm === undefined) ? '' : confirm.contents.replace(/(?:\r\n|\r|\n)/g, '<br>')
        }
      }
      localStorage.setItem('menuRequired', restaurant.menuRequired)
      commit('setStoreIdx', restaurantIdx)
      commit('restaurant', restaurant)
    } catch (error) {
      console.error('getRestaurantInfo error---', error)
    }
  }
}
